// extracted by mini-css-extract-plugin
module.exports = {"outerBox":"WordCloud__outerBox__fvfx0","errorMsg":"WordCloud__errorMsg__V+GKQ"};